var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcelUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.116,
    height: 48.175,
    viewBox: "0 0 74.116 48.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M54.647,19.737q-.005.217-.015.434a14.454,14.454,0,1,1,5.032,28.005l-.213,0-.158,0v0H37.371V25.944l8.99,9.1a1.914,1.914,0,0,0,2.73,0,1.972,1.972,0,0,0,0-2.765L36.806,19.843a1.914,1.914,0,0,0-2.73,0L21.79,32.283a1.972,1.972,0,0,0,0,2.765,1.914,1.914,0,0,0,2.73,0l8.99-9.1V48.175H17.047v0a17.417,17.417,0,0,1-.006-34.827A19.273,19.273,0,0,1,54.652,19.27Q54.652,19.5,54.647,19.737Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelUpload);
export default __webpack_public_path__ + "static/media/excelUpload.a09383499aa27183fbb28744fe5789a6.svg";
export { ForwardRef as ReactComponent };